import { IonContent, IonPage, useIonToast } from "@ionic/react";
import React from "react";
import clsx from "clsx";

import styles from "../common.module.scss";
import toastStyles from "../../../molecules/Toast/Toast.module.scss";
import { IFile } from "../../../state";
import {
  Context,
  fetchInitialData,
  updateTeacher,
  UPDATE_TEACHER_SUCCESS_MESSAGE,
  UPDATE_TEACHER_FAILURE_MESSAGE,
  clearSuccessMessage,
  clearErrorMessage,
  submittedRealizationListPath,
} from "../../../store/teacher";
import TeacherProfileForm from "../../../templates/TeacherProfileForm";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import EmbeddedHeader from "../../../organisms/teacher/Header/EmbeddedHeader";

const EditProfile = (prop: { history: any }) => {
  const { dispatch, contextState } = React.useContext(Context);
  // ページ遷移に対応するためmolecules/Toastではなくionicのトーストを使用する
  const [present] = useIonToast();
  const [calling, peep] = useWaitApiCall(contextState);
  const [isUpdating, setIsUpdating] = React.useState(false);
  const [passwordManager, setPasswordManager] = React.useState({
    isInputPasswordMode: false,
    password: "",
  });

  const updateFunc = React.useCallback(
    (password: string, photo: IFile | null) => {
      dispatch(peep(updateTeacher(contextState.teacher.id, password, photo)));
      setIsUpdating(true);
    },
    [dispatch, peep, contextState.teacher.id],
  );

  const cancelFunc = React.useCallback(() => {
    setPasswordManager({
      isInputPasswordMode: false,
      password: "",
    });
    prop.history.push(submittedRealizationListPath);
  }, [prop.history]);

  const handleShowToast = React.useCallback(
    (message: string, type: "success" | "danger") => {
      present({
        message,
        duration: 1500,
        position: "top",
        cssClass: toastStyles[type],
      });
    },
    [present],
  );

  React.useEffect(() => {
    if (contextState.success_message === UPDATE_TEACHER_SUCCESS_MESSAGE) {
      setIsUpdating(false);
      setPasswordManager({
        isInputPasswordMode: false,
        password: "",
      });
      handleShowToast(UPDATE_TEACHER_SUCCESS_MESSAGE, "success");
      dispatch(clearSuccessMessage());
      dispatch(fetchInitialData());
      prop.history.push(submittedRealizationListPath);
    }
    if (contextState.error === UPDATE_TEACHER_FAILURE_MESSAGE) {
      setIsUpdating(false);
      handleShowToast(UPDATE_TEACHER_FAILURE_MESSAGE, "danger");
      dispatch(clearErrorMessage());
    }
  }, [
    prop.history,
    dispatch,
    handleShowToast,
    contextState.success_message,
    contextState.error,
  ]);

  return (
    <IonPage>
      <IonContent className={clsx(styles.wrapper, styles.bgWhileBase)}>
        {contextState.teacher.id ? (
          <div className={styles.container}>
            <EmbeddedHeader title="プロフィール編集" />
            <TeacherProfileForm
              {...contextState.teacher}
              calling={calling}
              cancel={cancelFunc}
              school_name={contextState.school_name}
              classes={contextState.teacher.classes}
              isUpdating={isUpdating}
              password={passwordManager.password}
              isInputPasswordMode={passwordManager.isInputPasswordMode}
              setPasswordManager={setPasswordManager}
              update={updateFunc}
              error={contextState.error}
            />
          </div>
        ) : null}
      </IonContent>
    </IonPage>
  );
};

export default EditProfile;
